(function () {
  function initFaqAccordions(root) {
    const scope = root || document;
    const accordions = scope.querySelectorAll(".et-faq_accordion");

    accordions.forEach((accordion) => {
      if (accordion.dataset.accordionInitialized === "true") return;
      accordion.dataset.accordionInitialized = "true";

      const toggle = accordion.querySelector(".et-faq_accordion-toggle");
      const body = accordion.querySelector(".et-faq_accordion-body");

      if (!toggle || !body) return;

      toggle.addEventListener("click", function () {
        const isOpen = body.classList.contains("open");

        document.querySelectorAll(".et-faq_accordion-body").forEach((item) => {
          item.classList.remove("open");
          item.style.maxHeight = null;
        });

        document.querySelectorAll(".et-faq_accordion-toggle").forEach((item) => {
          item.classList.remove("active");
        });

        if (!isOpen) {
          body.classList.add("open");
          body.style.maxHeight = body.scrollHeight + "px";
          toggle.classList.add("active");
        }
      });
    });
  }

  function initFeaturesAccordions(root) {
    const scope = root || document;
    const accordions = scope.querySelectorAll(".et-features_accordion");

    accordions.forEach((accordion) => {
      if (accordion.dataset.accordionInitialized === "true") return;
      accordion.dataset.accordionInitialized = "true";

      const toggle = accordion.querySelector(".et-features_accordion-toggle");
      const body = accordion.querySelector(".et-features_accordion-body");

      if (!toggle || !body) return;

      toggle.addEventListener("click", function () {
        const isOpen = accordion.classList.contains("is-active");
        const group = accordion.closest("section") || document;

        group.querySelectorAll(".et-features_accordion").forEach((item) => {
          const itemBody = item.querySelector(".et-features_accordion-body");

          item.classList.remove("is-active");

          if (itemBody) {
            itemBody.style.maxHeight = null;
          }
        });

        if (!isOpen) {
          accordion.classList.add("is-active");
          body.style.maxHeight = body.scrollHeight + "px";
        }
      });
    });
  }

  function initInfoCollapse(root) {
    const scope = root || document;
    const wrappers = scope.querySelectorAll(".et-faq_info");

    wrappers.forEach((collapsible) => {
      const section = collapsible.closest("section") || document;
      const toggleButton = section.querySelector(".et-info_button");
      const gradient = section.querySelector(".et-info_collapse");

      if (!toggleButton || !collapsible) return;
      if (toggleButton.dataset.collapseInitialized === "true") return;

      toggleButton.dataset.collapseInitialized = "true";
      toggleButton.dataset.expanded = "false";

      toggleButton.addEventListener("click", function () {
        const isExpanded = toggleButton.dataset.expanded === "true";
        const nextState = !isExpanded;

        toggleButton.dataset.expanded = String(nextState);
        collapsible.style.maxHeight = nextState ? collapsible.scrollHeight + "px" : 0;

        if (gradient) {
          gradient.classList.toggle("hide", nextState);
        }
      });
    });
  }

  function updateOpenedHeights() {
    document.querySelectorAll(".et-faq_accordion-body.open").forEach((body) => {
      body.style.maxHeight = body.scrollHeight + "px";
    });

    document.querySelectorAll(".et-features_accordion.is-active .et-features_accordion-body").forEach((body) => {
      body.style.maxHeight = body.scrollHeight + "px";
    });

    document.querySelectorAll(".et-info_button[data-expanded='true']").forEach((button) => {
      const section = button.closest("section") || document;
      const collapsible = section.querySelector(".et-faq_info");

      if (collapsible) {
        collapsible.style.maxHeight = collapsible.scrollHeight + "px";
      }
    });
  }

  function initAccordions(root) {
    initFaqAccordions(root);
    initFeaturesAccordions(root);
    initInfoCollapse(root);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAccordions(document);
    });
  } else {
    initAccordions(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAccordions(event.target);
  });

  let resizeTimer;

  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(function () {
      updateOpenedHeights();
    }, 150);
  });
})();